import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <div className="hs-section">
      <div className="hs-image">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fvilla6.webp?alt=media&token=c7e45f97-650b-4466-a281-93db0da30864"
          alt="Luxury Villa"
        />
      </div>
      <div className="hs-text">
        <p className="hs-label">Exclusive Membership</p>
        <h1 className="hs-title">Curated Membership, for the Discerning</h1>
        <p className="hs-desc">A private circle with privileged access to Luxe Unbounded residences.
                              Created for those who value space, privacy, and a sense of belonging.</p>
        <p className="hs-desc"><b>By Invitation Only</b></p>
        <Link to='/about-membership'><button className="hs-btn">Seek Invitation</button></Link>
      </div>
    </div>
  );
};

export default AboutSection;
